export default (setA, setB) => {
  const difference = new Set(setA);
  // eslint-disable-next-line no-restricted-syntax
  for (const elem of setB) {
    difference.delete(elem);
  }

  return Array.from(difference);
};
